var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActioms02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7a934f",
    d: "M13.46 13.53a7.054 7.054 0 0 1-9.988 0c-2.763-2.762-2.763-7.296 0-10.058 2.762-2.763 7.296-2.763 10.058 0 2.763 2.762 2.692 7.296-.07 10.058zm-1.984-3.046L9.493 8.501l1.983-1.983-.992-.992-1.983 1.983-1.983-1.983-.992.992L7.509 8.5l-1.983 1.983.992.992L8.5 9.493l1.983 1.983z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActioms02);
export default __webpack_public_path__ + "static/media/actioms02.081238fe19d33e9dfc51203b9dde4486.svg";
export { ForwardRef as ReactComponent };